import axios from 'axios';
import Cookies from 'js-cookie';

const instance = axios.create({
  baseURL: `${process.env.REACT_APP_API_BASE_URL}`,
  timeout: 50000,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
});

const getAdminInfo = () => {
  try {
    const raw = Cookies.get('adminInfo');
    return raw ? JSON.parse(raw) : null;
  } catch (e) {
    Cookies.remove('adminInfo');
    return null;
  }
};

// Add a request interceptor
instance.interceptors.request.use(function (config) {
  const adminInfo = getAdminInfo();
  const company = Cookies.get('company') || null;

  return {
    ...config,
    headers: {
      ...config.headers,
      authorization: adminInfo?.token ? `Bearer ${adminInfo.token}` : null,
      company,
    },
  };
});

instance.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;
    const message =
      error?.response?.data?.message || error?.response?.data?.error || "";

    // Sanctum auth failure only (this API also returns 401 for permission errors)
    if (
      status === 401 &&
      /unauthenticated/i.test(String(message)) &&
      window.location.pathname !== "/login"
    ) {
      Cookies.remove("adminInfo");
      window.location.replace("/login");
    }
    return Promise.reject(error);
  }
);

const responseBody = (response) => response.data;

const requests = {
  get: (url, body, headers) =>
    instance.get(url, body, headers).then(responseBody),

  post: (url, body) => instance.post(url, body).then(responseBody),

  put: (url, body, headers) =>
    instance.put(url, body, headers).then(responseBody),

  patch: (url, body) => instance.patch(url, body).then(responseBody),

  delete: (url, body) => instance.delete(url, body).then(responseBody),
};

export default requests;
